import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import FTMD from './FTMD';
import IntroMD from './IntroMD';
import ResultsMD from './ResultsMD';
import SUGMD from './SUGMD';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const MolecularDockingLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#IntroMD') {
      setBackI(appColors['ColorC']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#FTMD') {
      setBackI('transparent');
      setBackII(appColors['ColorC']);
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#SUGMD') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorC']);
      setBackIV('transparent');
    } else if (key === '#ResultsMD') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorC']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#IntroMD' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorC'], fontSize: '3vh'}}>Introduction</Text></Content>}/>
          <Link href='#FTMD' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorC'], fontSize: '1.2vh'}}>Fundamentals and troubleshooting</Text></Content>}/>
          <Link href='#SUGMD' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorC'], fontSize: '1.7vh'}}>Software usage guide</Text></Content>}/>
          <Link href='#ResultsMD' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorC'], fontSize: '3vh'}}>Results</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorC'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> D&nbsp;<br/> O&nbsp;<br/> C&nbsp;<br/> K&nbsp;<br/> I&nbsp;<br/> N&nbsp;<br/> G&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='IntroMD'>
              <IntroMD/>
            </div>
            <div id='FTMD'>
              <FTMD/>
            </div>
            <div id='SUGMD'>
              <SUGMD/>
            </div>
            <div id='ResultsMD'>
              <ResultsMD/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MolecularDockingLogic;
